export { default } from '../en/Privacy';



// WEBPACK FOOTER //
// ./src/components/async/enPrivacy.js